import React from 'react';
import './WhatWeDo.css';

const WhatWeDo = () => {
  const services = [
    {
      category: 'Marketing & Growth',
      icon: '📈',
      items: [
        'Digital Marketing',
        'Activation Campaigns',
        'Media Buying',
        'Response Management',
        'Campaign Development'
      ]
    },
    {
      category: 'Creative & Content',
      icon: '✨',
      items: [
        'Content Creation',
        'Brand Storytelling',
        'Analytics & Reporting',
        'Branding & Identity'
      ]
    },
    {
      category: 'Brand Strategy',
      icon: '🎯',
      items: [
        'Logos & Identity',
        'Brand & Visual Guidelines',
        'Interior Branding',
        'Outdoor & Signage Solutions'
      ]
    }
  ];

  return (
    <section id="what-we-do" className="what-we-do">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">What We Do</h2>
          <p className="section-subtitle">
            Comprehensive creative solutions tailored to elevate your brand
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-category">{service.category}</h3>
              <ul className="service-items">
                {service.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="service-item">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;

